import type { components } from "admination-react/api-schema";
import { sendJson, type WriteIdentity } from "./http";

export type RenderFamily = "bericht" | "vertrag";

export type RenderedDocument = components["schemas"]["RenderedDocument"];

export function renderSignedDocument(
  family: RenderFamily,
  coachingId: string,
  identity?: WriteIdentity,
): Promise<RenderedDocument> {
  return sendJson<RenderedDocument>(`/documents/render/${family}`, "POST", {
    coaching_id: coachingId,
  }, undefined, identity);
}
